<p-table #dt
  class="table-parameters table-simple-paginator m-4"
  [alwaysShowPaginator]="false"
  [value]="groups"
  [columns]="cols"
  [paginator]="true"
  [rows]="amountOfRows"
  [totalRecords]="totalRecords"
  [filterDelay]="1000"
  [loading]="isLoading"
  responsiveLayout="scroll"
  [defaultSortOrder]="defaultSortOrder"
  [sortField]="defaultSortField">
<ng-template pTemplate="header" let-columns>
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field">
        <div class="flex items-center gap-2">
          {{col.header}}
          @if (col.field && col.header !=='') {
            <p-sortIcon
              [field]="col.field"
              aria-label="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            />
          }
        </div>
      </th>
    }
  </tr>
</ng-template>
<ng-template pTemplate="emptymessage" let-columns>
  <tr>
    <td [attr.colspan]="columns.length">
      <p>{{ isLoading ? 'Loading... please wait' : 'No record found' }}</p>
    </td>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-group>
  <tr>
    <td>{{ group.displayName }}</td>
  </tr>
</ng-template>
</p-table>
